var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Date",staticStyle:{"display":"inline-block"}},[_c('p',{staticClass:"date"},[_vm._v(_vm._s(_vm.h + ':' + _vm.m + ':' + _vm.s))])])
}
var staticRenderFns = []

export { render, staticRenderFns }